import { useEffect, useState } from 'react';

import _ from 'lodash';

import PropTypes from 'prop-types';

import BuildingDetails from '../../../components/building-details/building-details.component';

import { cmsService } from '../../../services/homii-services';

import { Layout, Footer, MetaData } from '../../../components/shared';

import { buildingDomain, cityDomain, roomTypesDomain, portfolioDomain } from '../../../domain';

const BuildingDetailsPage = (props) => {
    
    const { seoData, building, cities, cmsData } = props;
    
    const seoTitle = _.get(seoData, 'acf.seo_title');
    const seoMetaDesc = _.get(seoData, 'acf.seo_meta_description');

    const [roomTypes, setRoomTypes] = useState([]);

    const [roomTypeSummaries, setRoomTypeSummaries] = useState([]); 
    
    const [allPorfolios, setPorfolios] = useState([]); 

    useEffect(() => {

        if (!building) return;

        const asyncSearch = async () => {
            const rooms = await roomTypesDomain.checkRoomTypeAvailabilityPerBuilding(building);
            setRoomTypes(rooms);

            const summaries = await roomTypesDomain.fetchRoomTypeSummaryAvailabilityPerBuilding(building);
            setRoomTypeSummaries(summaries);

            const porfolios = await portfolioDomain.fetchAllPortfolios();
            setPorfolios(porfolios);
        };        

        asyncSearch();

    }, [building]);    

    return (
        <Layout>

            <MetaData title={seoTitle} desc={seoMetaDesc} />

            <BuildingDetails 
                selectedBuilding={building} 
                cities={cities} 
                cmsData={cmsData}
                selectedBuildingRoomTypes={roomTypes}
                selectedBuildingRoomTypesSummary={roomTypeSummaries}
                allPortfolios={allPorfolios}
            />

            <Footer  />
        </Layout>
    );
};

export default BuildingDetailsPage;

export const getServerSideProps = async ({ query }) => {
    
    const buildingId = _.get(query, 'buildingId');
    const cmsData = await cmsService.RetrieveWordPressPage('buildings');
    const seoData = _.get(cmsData, 'acf');
    const building = await buildingDomain.fetchBuildingById(buildingId);
    const cities = await cityDomain.fetchAllCitiesData();

    return {
        props: {
            seoData, building, cities, cmsData
        }
    }
};

BuildingDetailsPage.propTypes = {
    seoData: PropTypes.object,
};
